import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import StoryCardDLTextOverley from "../../atoms/story-card-dl-text-overley";
import SmallStoryCardCurve from "../../atoms/small-story-card-curve";
import { getPagePath } from "../../../data/collection";

import styles from "./styles.m.css";
import { VikatanMainResponsive } from "../ad-free";
import Icon from "../../atoms/icon";

const ThirteenStoryOneAdOneWidgetWithLivenews = ({
  collection,
  metadata,
  accentColor,
  showReadmore = true,
  pagetype = "",
  index,
  stories,
  className,
  mobileStoryCount,
  verticalimg = true,
  sectionpagetemplate = true,
  sectionpagetemplateBigcard = true,
  sectionpagetemplatelargetext = true,
  sectionpageBigcard = true,
  borderbox = true
}) => {
  if (stories.length < 1) {
    return null;
  }

  const [userType = "F", setType] = useState(false);

  const CurrentDate = new Date().toISOString().split("T")[0];

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      setType(user.userType);
    });
  }, []);

  return (
    <div>
      {userType === "P" || userType === "T" ? (
        <div className={`${styles["base"]}`}>
          <div className={`${styles["card"]} container`}>
            <div className={styles["page-content-grid-paid"]}>
              <div className={styles["main-content-paid"]}>
                <StoryCardDLTextOverley
                  story={stories[0]}
                  sectionpageBigcard={sectionpageBigcard}
                  className={styles["first-big-card"]}
                />

                <div className={styles["paid-stories"]}>
                  <div>
                    <div key="live-news" className={styles["live-news-section"]}>
                      <a
                        href={`https://www.vikatan.com/live/today-news-articles-${CurrentDate}`}
                        className={styles["live-news-wrapper"]}
                      >
                        <div className={styles["hero-image-wrapper"]}>
                          <img
                            src="https://media.vikatan.com/vikatan/2025-07-04/61ynlgtg/livenews.png?rect=0%2C0%2C1920%2C1080&q=75&auto=format%2Ccompress&w=634"
                            alt="Live News"
                          />
                        </div>
                        <div>
                          <span className={styles["liveblink"]}>
                            <span className={styles["livenow"]}>Live News</span>
                          </span>
                          <h1 className={styles["headline"]}>
                            நேரலை செய்திகள்: இன்று வெளியான News Articles - {CurrentDate}
                          </h1>
                        </div>
                      </a>
                    </div>

                    {stories.slice(1, 3).map(story => (
                      <SmallStoryCardCurve
                        story={story}
                        verticalimg={verticalimg}
                        sectionpagetemplatelargetext={sectionpagetemplatelargetext}
                        key={story.id}
                      />
                    ))}
                  </div>

                  <div className={styles["paid-right-stories"]}>
                    {stories.slice(3, 6).map(story => (
                      <SmallStoryCardCurve
                        story={story}
                        verticalimg={verticalimg}
                        sectionpagetemplatelargetext={sectionpagetemplatelargetext}
                        key={story.id}
                      />
                    ))}
                  </div>
                </div>

                <div className={styles["rest-stories"]}>
                  {stories.slice(6, 12).map(story => (
                    <SmallStoryCardCurve story={story} verticalimg={verticalimg} borderbox={borderbox} key={story.id} />
                  ))}
                </div>

                <div className={styles["read-more-wrapper"]}>
                  {showReadmore && (
                    <Link href={getPagePath(collection)} text={"மேலும் படிக்க"} className={styles["read-more"]}>
                      <span>மேலும் படிக்க</span>
                      <Icon type="slider-next" className={styles["arrow"]} />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={`${styles["base"]}`}>
          <div className={`${styles["card"]} container`}>
            <div className={`${styles["page-content-grid"]}`}>
              <div className={styles["main-content"]}>
                <StoryCardDLTextOverley
                  story={stories[0]}
                  sectionpageBigcard={sectionpageBigcard}
                  className={styles["first-big-card"]}
                />

                <div key="live-news" className={styles["live-news-section"]}>
                  <a
                    href={`https://www.vikatan.com/live/today-news-articles-${CurrentDate}`}
                    className={styles["live-news-wrapper"]}
                  >
                    <div className={styles["hero-image-wrapper"]}>
                      <img
                        src="https://media.vikatan.com/vikatan/2025-07-04/61ynlgtg/livenews.png?rect=0%2C0%2C1920%2C1080&q=75&auto=format%2Ccompress&w=634"
                        alt="Live News"
                      />
                    </div>
                    <div>
                      <span className={styles["liveblink"]}>
                        <span className={styles["livenow"]}>Live News</span>
                      </span>
                      <h1 className={styles["headline"]}>
                        நேரலை செய்திகள்: இன்று வெளியான News Articles - {CurrentDate}
                      </h1>
                    </div>
                  </a>
                </div>

                <SmallStoryCardCurve
                  story={stories[1]}
                  verticalimg={verticalimg}
                  sectionpagetemplatelargetext={sectionpagetemplatelargetext}
                  key={stories[1].id}
                  className={`${styles["small-story-1"]} ${styles["line-separater"]}`}
                />

                <SmallStoryCardCurve
                  story={stories[2]}
                  verticalimg={verticalimg}
                  sectionpagetemplatelargetext={sectionpagetemplatelargetext}
                  key={stories[2].id}
                  className={`${styles["small-story-2"]} ${styles["line-separater"]}`}
                />

                <div className={`${styles["sidebar"]} hidden-mobile`}>
                  <VikatanMainResponsive
                    placement={pagetype}
                    MobileAdtype="Vikatan_mrec_mid_SP"
                    DesktopAdtype="Vikatan_Desktop_SP_ATF_Right_300x250"
                  />
                </div>

                <div className={styles["rest-stories"]}>
                  {stories.slice(3, 12).map(story => (
                    <SmallStoryCardCurve story={story} verticalimg={verticalimg} borderbox={borderbox} key={story.id} />
                  ))}
                </div>

                <div className={styles["read-more-wrapper"]}>
                  {showReadmore && (
                    <Link href={getPagePath(collection)} text={"மேலும் படிக்க"} className={styles["read-more"]}>
                      <span>மேலும் படிக்க</span>
                      <Icon type="slider-next" className={styles["arrow"]} />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ThirteenStoryOneAdOneWidgetWithLivenews.propTypes = {
  metadata: PropTypes.shape({
    read_more_text: PropTypes.string
  }),
  accentColor: PropTypes.string,
  showReadmore: PropTypes.bool,
  bigimage: PropTypes.bool,
  verticalimg: PropTypes.bool,
  sectionpagetemplate: PropTypes.bool,
  sectionpagetemplateBigcard: PropTypes.bool,
  sectionpagetemplatelargetext: PropTypes.bool,
  sectionpageBigcard: PropTypes.bool,
  collection: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape(StoryCardDLTextOverley.propTypes))
  }),
  stories: PropTypes.arrayOf(StoryCardDLTextOverley.propTypes.story),
  className: PropTypes.string,
  pagetype: PropTypes.string,
  index: PropTypes.number,
  mobileStoryCount: PropTypes.number,
  borderbox: PropTypes.bool
};
ThirteenStoryOneAdOneWidgetWithLivenews.storyLimit = 13;

export default ThirteenStoryOneAdOneWidgetWithLivenews;
